module.exports = __webpack_public_path__ + "static/Boiler_form_EN-e9d160f8c276b2003fd71b18222b34a2.pdf";